import React from 'react'
import "./Navbar.css"
import logo from "../images/jlogo.png"
function Navbar() {
  return (
    <div>
      <nav class="navbar navbar-expand-lg bg-body-transparent">
        <div class="container-fluid">
        <a class="navbar-brand" href="#">
      <img class="jupor-logo" src={logo}/>
    </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarTogglerDemo02" >
            <ul class="navbar-nav mb-2 mb-lg-0" style={{marginLeft:"auto"}}>
              <li class="nav-item">
                <a class="nav-link" href="/">
                  Home
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Contact Us
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="/IndianOffice">
                      Indian Office
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="/CanadianOffice">
                      Canadian Office
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Companies
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="/">
                      Jupor Consultants
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="https://enrolme.io">
                      Enrolme Education
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="https://theworkly.co">
                      Workly
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="https://businessblvd.ca">
                      Business Blvd inc.
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Navbar
